import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SimpleChartWithTableComponent } from 'app/trello/components/shared/visualisations/simple-chart-with-table/simple-chart-with-table.component';
import { ChartableData, LabelledValues } from 'app/trello/models/charts';
import { ChartOptions, ChartType } from 'chart.js';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SimpleChartWithTableComponent,
  ],
  selector: 'app-sparkline-chart',
  template: `
      <app-simple-chart-with-table
              [chartData]="chartData"
              [chartType]="chartType"
              [chartLegend]="chartLegend"
              [chartOptions]="chartOptions"
              [chartContainer]="chartContainer"></app-simple-chart-with-table>
  `,
})
export class SparklineChartComponent {

  @Input({required: true}) chartData!: ChartableData<LabelledValues, never>;

  @Input() chartContainer: HTMLElement | undefined = undefined;

  protected readonly chartType: ChartType = 'line';
  protected readonly chartLegend: boolean = false;
  protected readonly chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,         // hide X axis
        grid: {display: false}, // hide grid lines
      },
      y: {
        display: false,         // hide Y axis
        grid: {display: false}, // hide grid lines
      },
    },
    plugins: {
      tooltip: {enabled: false},// disable tooltips
      legend: {display: false}, // hide legend
    },
    elements: {
      line: {
        tension: 0.1,   // smooth curve
        borderWidth: 2, // line width
      },
      point: {
        radius: 0, // hide points
      }
    },
    animation: {
      duration: 0, // no animations
    },
  };

}
